// Iter 137 — Compact TV-listings affordance for match cards.
// One click navigates to the match detail page with `?tv=1` so the
// landing page can auto-open the analysis modal and scroll directly
// to the "Where to Watch" section.  We don't pre-fetch broadcasters
// per card (rate-limit safe): the button is a routing affordance,
// not a confidence signal.

import { useNavigate } from "react-router-dom";
import { Tv } from "lucide-react";

export const TVBadge = ({ matchId, compact = false, className = "" }) => {
  const navigate = useNavigate();
  if (!matchId) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/match/${matchId}?tv=1`);
  };

  if (compact) {
    return (
      <button
        type="button"
        onClick={handleClick}
        data-testid={`tv-badge-${matchId}`}
        title="Where to watch on TV"
        className={[
          "inline-flex items-center justify-center w-7 h-7 rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-500 dark:text-cyan-400 hover:bg-cyan-500/20 transition shrink-0",
          className,
        ].join(" ")}
      >
        <Tv className="w-3.5 h-3.5" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={`tv-badge-${matchId}`}
      className={[
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border border-cyan-500/30 bg-cyan-500/10 text-cyan-500 dark:text-cyan-400 text-[10px] font-bold tracking-[0.04em] hover:bg-cyan-500/20 transition",
        className,
      ].join(" ")}
      title="Where to watch on TV"
    >
      <Tv className="w-3 h-3" />
      WHERE TO WATCH
    </button>
  );
};

export default TVBadge;
